class BaseException extends Error {
  constructor(message, name) {
    super(message);
    this.name = name;
  }
}

class FormatError extends BaseException {
  constructor(message) {
    super(message, "FormatError");
  }
}

const shadow = (obj, prop, value) => {
  Object.defineProperty(obj, prop, {
    value,
    enumerable: true,
    configurable: true,
    writable: true,
  });
  return value;
};

const info = () => {};

export { BaseException, FormatError, info, shadow };
